import React, {Component} from "react";

/*
* Authentication & navigation
*/
import Alt from 'alt';
import history from '../../../history';
import axios from 'axios';
import AuthActions from '../../../actions/AuthActions';
import AuthStore from '../../../stores/AuthStore';
import routes from '../../../routes';

import classnames from "classnames";

class DashboardAdmin extends Component {
    render() {

        return (
            <div>
                <h1>Home do Admin</h1>
            </div>
        )
    }
}

export default DashboardAdmin;



// WEBPACK FOOTER //
// ./src/views/Dashboard/admin/DashboardAdmin.js